import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SetupService } from '@core/services/setup';

import { FederationService } from './federation.service';

@Component({
    selector: 'app-federation',
    templateUrl: './federation.component.html',
    styleUrls: ['./federation.component.scss'],
})
export class FederationComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    pageTitle = this.translateService.instant('PAGES.FEDERATION');

    constructor(
        private federationService: FederationService,
        private title: Title,
        private setupService: SetupService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        //console.log('federation list');
        this.federation();
        this.title.setTitle(`${this.pageTitle} - ${this.setupService.title}`);
    }

    /**
     * federation() - Buscar lista de federações
     */
    federation() {
        this.federationService.getFederation().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        //console.log('FederationComponent successCallbackApi');
        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    onPageChange(pageNumber) {
        //console.log(pageNumber);
    }
}
